import React from "react";

// icons : feather
import FeatherIcon from 'feather-icons-react';

export default function AppFormikInputFieldCheckbox(props) {
    const {
        formik,
        stFormClass,
        labelName,
        isRequired,
        formikFieldName,
        isRound
    } = props;

    return (
        <div
            className={`st-form ${stFormClass || ""} ${formik.touched[formikFieldName] &&
                formik.errors[formikFieldName]
                ? "has-msg msg-error"
                : ""
                }`}
        >
            {labelName ? (
                <label>
                    {labelName}
                    {isRequired && <span className="required ms-1 st-fs-12">(required)</span>}
                </label>
            ) : null}
            <div className="media-body st-form-input-container" style={{ textAlign: 'left' }}>
                <label
                    className={`st-checkbox st-checkbox-primary d-inline-flex cursor-pointer position-relative ${isRound ? "rounded-circle" : ""}`}
                    style={{ top: 3 }}>
                    <input
                        type="checkbox"
                        className="d-none"
                        id={formikFieldName}
                        checked={formik.values[formikFieldName]}
                        {...formik.getFieldProps(formikFieldName)}
                    />
                    <span className="box d-flex align-items-center justify-content-center border">
                        <FeatherIcon
                            icon="check"
                            size="15"
                            className="icon position-relative" />
                    </span>
                </label>
                {
                    /* form message */
                    formik.touched[formikFieldName] &&
                    formik.errors[formikFieldName] && (
                        <div className="st-form-msg position-absolute" style={{ bottom: -18 }}>
                            <p className="st-fs-12">
                                {formik.errors[formikFieldName]}
                            </p>
                        </div>
                    )
                }
            </div>
        </div>
    );
}
